import React, { useState, useEffect, useRef } from 'react';
import SelectColumnBox from '../../Analysis/SelectColumnBox';
import { X } from 'lucide-react';


const SelectColumnContainer = ({ selectedAccount, setSelectedAccount, clearSearchTerm=true }) => {
    const [showSelectBox, setShowSelectBox] = useState(false);
    const [searchTerm, setSearchTerm] = useState(""); // 検索文字列の状態
    const containerRef = useRef(null);
    const [displayAccount, setDisplayAccount] = useState(null);

    const handleClickOutside = (event) => {
        if (containerRef.current && !containerRef.current.contains(event.target)) {
            setShowSelectBox(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        setDisplayAccount(selectedAccount?.col_name || "");
    }, [selectedAccount]);

    const handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            e.preventDefault();
            setShowSelectBox(false);
        }
    };

    const onAccountClick = (account) => {
        setDisplayAccount(account.col_name);
        setSelectedAccount(account);
        setShowSelectBox(false);
        if (clearSearchTerm) {
            setSearchTerm(''); // 検索状態をリセット
        } else {
            setSearchTerm(account.col_name); // 検索状態をリセット
        }
        
    };

    const deleteColumn = () => {
        setSearchTerm('');
        setDisplayAccount('');
    }

    return (
        <div className="summary-graph-selected-column-container w-[400px] max-w-[100%]">
            <div className="column-container">
                <div className="summary-graph-search-company-input column-input w-full" ref={containerRef}>
                    <div className="textarea-icon-container textarea-narrow w-full relative">
                        <i className="fa-solid fa-magnifying-glass textarea-icon"></i>
                        <textarea
                            id="column-search"
                            className="search-area wide-search-area border-gray-400"
                            name="message"
                            placeholder="表示したい項目を選んでください"
                            rows="1"
                            value={displayAccount}
                            onFocus={() => setShowSelectBox(true)}
                            onKeyDown={handleKeyDown}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setDisplayAccount(e.target.value);
                                setShowSelectBox(true); // テキスト変更時にボックスを開く
                            }}
                        ></textarea>
                        <div className='w-6 h-6 absolute top-[8px] right-5 rounded-full hover:bg-gray-300 flex justify-center items-center' onClick={deleteColumn}>
                            <X size={17} color="#646464" />
                        </div>
                        
                        {showSelectBox && (
                            <SelectColumnBox
                                setAccount={onAccountClick}
                                searchTerm={searchTerm} // 検索文字列を渡す
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SelectColumnContainer;
